import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./components/pages/Home";
import About from "./components/pages/About";
import Service from "./components/pages/Service";
import Feature from "./components/pages/Feature";
import Countries from "./components/pages/Countries";
import Testimonial from "./components/pages/Testimonial";
import Training from "./components/pages/Training";
import Contact from "./components/pages/Contact";
import NotFound from "./components/pages/NotFound";
import VisaCenterPage from "./components/pages/visa-center";
import VisaDetails from "./components/pages/VisaDetails";
import Gallery from "./components/pages/Gallery";
import './transitions.css';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/visa-center" element={<VisaCenterPage />} />
          <Route path="/visa-details/:country" element={<VisaDetails />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/about" element={<About />} />
          <Route path="/service" element={<Service />} />
          <Route path="/feature" element={<Feature />} />
          <Route path="/countries" element={<Countries />} />
          <Route path="/testimonial" element={<Testimonial />} />
          <Route path="/training" element={<Training />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
